import React from 'react';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';

import Container from 'components/common/Container/index';

import ProLayout from './ProLayout';

import {
  Wrapper,
} from './styles';

const Results = () => (
  <Container>
    <Wrapper>
      <Tabs defaultIndex={0}>
        <TabList>
          <Tab>VG Pro</Tab>
        </TabList>
        <TabPanel>
          <ProLayout />
        </TabPanel>
      </Tabs>
    </Wrapper>
  </Container>
);

Results.propTypes = {};

export default Results;
